import instance, { instanceFile } from "../../ApiConfig";
import { URLS } from "../../ApiConfig/Urls";

const fetchVehicleType = async () => {
  try {
    const response = await instance.get(URLS.GetAdmin + URLS.GetVehicleType);

    if (response.status === 200) {
      return response.data;
    }

    throw new Error("Failed to fetch Vehicle Value");
  } catch (error) {
    console.error(error);
    throw error;
  }
};

const fetchVehicleValueByID = async (ValueID) => {
  try {
    const response = await instance.get(
      URLS.GetVehicleValue + ValueID + "/by-id/",
    );

    if (response.status === 200) {
      return response.data;
    }

    throw new Error("Failed to fetch Vehicle Value");
  } catch (error) {
    throw error;
  }
};

const fetchVehicleValueByVehicle = async (VehicleID) => {
  try {
    const response = await instance.get(
      URLS.GetVehicleValue + "by-vehicle/" + VehicleID + "/",
    );

    if (response.status === 200) {
      return response.data;
    }

    throw new Error("Failed to fetch Vehicle Value");
  } catch (error) {
    throw error;
  }
};

const createVehicleType = async (vehicleData) => {
  try {
    const response = await instanceFile.post(
      URLS.GetAdmin + URLS.AddVehicleType,
      vehicleData,
    );
    if (response.status === 201) {
      return response.data;
    }
    return null;
  } catch (error) {
    console.error(error);
  }
};

const updateVehicleValue = async (updateVehicleValueData, ValueID) => {
  try {
    const response = await instanceFile.put(
      URLS.GetVehicleValue + ValueID + "/",
      updateVehicleValueData,
    ); // Adjust the URL as needed
    if (response.status === 200) {
      console.log("Vehicle Value Updated successfully");
      return response.data;
    } else {
      return null;
    }
  } catch (error) {
    console.error("Error sending verification code:", error);
    return null;
  }
};

const deleteVehicleValue = async (ValueID) => {
  try {
    const response = await instance.delete(
      URLS.GetVehicleValue + ValueID + "/",
    );
    if (response.status === 204) {
      return response;
    }
    return null;
  } catch (error) {
    console.error(error);
    return null;
  }
};

export default {
  fetchVehicleType,
  fetchVehicleValueByVehicle,
  fetchVehicleValueByID,
  createVehicleType,
  updateVehicleValue,
  deleteVehicleValue,
};
